// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_TYPE_NOTES = "GET_TYPE_NOTES";
export const CREATE_TYPE_NOTES = "CREATE_TYPE_NOTES";
export const UPDATE_TYPE_NOTES = "UPDATE_TYPE_NOTES";
export const DELETE_TYPE_NOTES = "DELETE_TYPE_NOTES";
